import { toast } from 'react-toastify';

/**
 * Toast notification utility for consistent user feedback.
 * Replaces browser alert() with non-blocking notifications.
 */
export const notify = {
    /**
     * Show a success notification
     * @param {string} message - The message to display
     */
    success: (message) => toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    }),

    /**
     * Show an error notification
     * @param {string} message - The error message to display
     */
    error: (message) => toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    }),

    /**
     * Show a warning notification
     * @param {string} message - The warning message to display
     */
    warning: (message) => toast.warning(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    }),

    /**
     * Show an info notification
     * @param {string} message - The info message to display
     */
    info: (message) => toast.info(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    }),
};

export default notify;
